// extracted by mini-css-extract-plugin
module.exports = {"module2":"module2_module2__pxEoE","module2Container":"module2_module2Container__aF5C1"};